
import { WorldCountry } from '../types';
import { chileExpanded } from './chileExpansion';
import { venezuelaExpanded } from './venezuelaExpansion';

export const southAmericaExpansion2: WorldCountry[] = [
  chileExpanded,
  venezuelaExpanded
];
